import React, { useEffect, useState } from "react";
import * as S from "./Emr";
import Toolbar from "../shared/toolbar";
import FoldersList from "./components/foldersList";
import FolderContent from "./components/folderContent";
import FolderRecords from "./components/folderRecords";


function Emr () {

  return (
    <S.Emr>
      <div className="emr-toolbar">
        <Toolbar/>
      </div>
      <div className="emr-content">
        {
          false 
          ? 
          <>
            <div className="emr-content__left">
              <FoldersList/>
            </div>
            <div className="emr-content__right">
              <FolderContent/>
            </div>
          </>
          : <FolderRecords/>
        }
      </div>
    </S.Emr>
  )

}

export default Emr;
